/** Resolve current UTF-16 positions from the rhèse anchor and local letter index. */
export function getLetterPosition(node: Node | null | undefined): number | undefined {
  const element = node?.nodeType === 1 ? node as Element : node?.parentElement;
  const letter = element?.closest<HTMLElement>(".letter,.ponctuation");
  const start = letter?.closest<HTMLElement>(".rhese")?.dataset.absolutePosition;
  const index = letter?.dataset.index;
  if (start === undefined || index === undefined) return undefined;
  const position = Number(start) + Number(index);
  return Number.isFinite(position) ? position : undefined;
}
